import { Shimmer } from '@wartek-id/shimmer'

import Accordion from './Accordion'
import DataBlock from './DataBlock'
import DataBlockLoading from './DataBlockLoading'
import DataInfo from './DataInfo'
import { formatDate } from 'utils/datetime'
import { getIsValidIdentity } from './helpers/data-validation'

import type { IBCKSKepalaSekolahEligibility } from 'types/bcks'
import type { FC } from 'react'

interface BlockIdentityProps {
  isLoading?: boolean
  data: IBCKSKepalaSekolahEligibility['identity']
}

const BlockIdentity: FC<BlockIdentityProps> = ({ isLoading = false, data }) => {
  const direction = 'horizontal'

  return (
    <Accordion
      isLoading={isLoading}
      title="Identitas"
      isError={!isLoading && !getIsValidIdentity(data)}
    >
      <div className="space-y-4">
        {isLoading && (
          <>
            {Array.from({ length: 7 })?.map((_, index) => (
              <DataBlockLoading
                direction={direction}
                index={index}
                key={`loading-shimmer-identity-${index}`}
              />
            ))}
            <div className="bg-surface-subdued px-4 py-3 rounded">
              <Shimmer width="100%" />
            </div>
          </>
        )}

        {!isLoading && (
          <>
            <DataBlock direction={direction} label="Nama">
              {data?.nama.value || data?.nama.validation}
            </DataBlock>

            <DataBlock direction={direction} label="Tanggal lahir">
              {data?.tanggalLahir.value
                ? formatDate(data.tanggalLahir.value)
                : data?.tanggalLahir.validation}
            </DataBlock>

            <DataBlock
              direction={direction}
              label="Usia"
              isError={!!data?.umur.validation}
            >
              {data?.umur.validation || data?.umur.value}
            </DataBlock>

            <DataBlock direction={direction} label="Domisili">
              {data?.kecamatan.value ||
              data?.kabupaten.value ||
              data?.provinsi.value
                ? [
                    data.kecamatan.value,
                    data.kabupaten.value,
                    data.provinsi.value,
                  ].join(', ')
                : data?.kecamatan.validation ||
                  data?.kabupaten.validation ||
                  data?.provinsi.validation}
            </DataBlock>

            <DataBlock direction={direction} label="NIP">
              {data?.nip.value || data?.nip.validation}
            </DataBlock>

            <DataBlock direction={direction} label="NUPTK">
              {data?.nuptk.value || data?.nuptk.validation}
            </DataBlock>

            <DataBlock direction={direction} label="Masa Kerja">
              {data?.masaKerja.value
                ? `${data?.masaKerja.value} tahun`
                : data?.masaKerja.validation}
            </DataBlock>

            <DataInfo name="operator Dapodik" />
          </>
        )}
      </div>
    </Accordion>
  )
}
export default BlockIdentity
